import { useFilterConfig } from '@juvare/common-data-table-ui/FiltersBar';
import { useDocumentLibraryTranslations } from './useDocumentLibraryTranslations';
export function useFilesFilterConfig() {
    const { t } = useDocumentLibraryTranslations();
    return useFilterConfig((builder) => {
        builder.quickSearchFilter({ dataPath: 'search', label: t('common.search'), sx: { maxWidth: { xs: undefined, sm: 340 } } });
    }, [t]);
}
